import styled from '../../../../theme'

const ToolbarMobileContainer = styled.div<IToolbarMobileContainer>`
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 56;

  @media (min-width: ${props => props.theme.breakpoints.tablet}) {
    display: none;
  }
`

export default ToolbarMobileContainer

export interface IToolbarMobileContainer {
  summary?: boolean
}
